import * as THREE from 'three'
import SimplexNoise from './simplex-noise';
// import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'

import vertex from './shaders/vertex'
import fragment from './shaders/fragment'
import gsap from 'gsap'



function isMobile() {
    return !!(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i))
}
class BlobObject {
    constructor(t={}) {
        this.options = {
            element: t.element,
            zoom: t.zoom || 2.5,
            color: t.color || 16777215
        };
        this.speedSlider = 1;
        this.spikesSlider = .6;
        this.processingSlider = 1.3;
        this.canvas = this.options.element;
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.vertex = vertex;
        this.fragment = fragment;
        this.mouse = new THREE.Vector2()
        this.canvas.appendChild(this.renderer.domElement);
        this.simplex = new SimplexNoise;
        this.width = window.innerWidth
        this.height = window.innerHeight;
        this.renderer.setSize(this.width, this.height);
        this.renderer.setPixelRatio(window.devicePixelRatio || 1);
        this.scene = new THREE.Scene;
        this.camera = new THREE.PerspectiveCamera(45, this.width / this.height, .1, 1000);
        this.camera.position.set(0, 0, this.options.zoom);
        this.camera.lookAt(isMobile() ? -.8 : -.4, 0, 0);


        this.geometry = new THREE.SphereGeometry(1, 128, 128);
        this.material = new THREE.MeshPhongMaterial({
            color: this.options.color,
            shininess: 10
        });


        this.lightTop = new THREE.DirectionalLight(16777215,1);
        this.lightTop.position.set(0, 500, 300);
        this.lightTop.castShadow = true;
        this.scene.add(this.lightTop);
        this.lightTop = new THREE.AmbientLight(16777215,0.5);
        this.scene.add(this.lightTop);
        this.lightBottom = new THREE.DirectionalLight(16777215,1);
        this.lightBottom.position.set(0, 600, 100);
        this.lightBottom.castShadow = true;
        this.scene.add(this.lightBottom);

        this.sphere = new THREE.Mesh(this.geometry,this.material);
        this.scene.add(this.sphere);

        this.rAF = null;
        this.run = this.run.bind(this);
        window.addEventListener("resize", this.resize.bind(this));
        this.init()
        this.mouseMove();
    }


    //-----------  this is where the movement occurs ------------------//
    
    mouseMove() {
        window.addEventListener("mousemove", (event) => {
                this.mouse.x = (event.clientX / this.width) * 2 - 1
                this.mouse.y = -(event.clientY / this.height) * 2 + 1
                
                // gsap.to(this.sphere.position, {
                //     x: this.mouse.x/1.2,
                //     y: this.mouse.y/3,
                //     duration: 1.2,
                //     ease: "Power.easeOut",
                // })
        },
            false
        )
    }

    update() {
        this.time = 0.00001 * performance.now() * this.speedSlider * Math.pow(this.processingSlider, 5);
        this.spikes = this.spikesSlider * this.processingSlider;
        this.camera.position.z = this.options.zoom - 0;
        for (let t = 0; t < this.sphere.geometry.vertices.length; t++) {
            let e = this.sphere.geometry.vertices[t];
            e.normalize().multiplyScalar(1 + .09 * this.simplex.noise3D(e.x * this.spikes, e.y * this.spikes, e.z * this.spikes + this.time))
        }
        this.sphere.geometry.computeVertexNormals();
        this.sphere.geometry.normalsNeedUpdate = true;
        this.sphere.geometry.verticesNeedUpdate = true;

        this.sphere.rotation.y += 0.008;
    }
    run() {
        this.update();
        this.renderer.render(this.scene, this.camera);
        this.raf()
    }
    raf() {
        this.rAF = requestAnimationFrame(this.run)
    }
    init() {
        this.raf()
    }
    cancel() {
        window.cancelAnimationFrame(this.rAF)
    }
    resize() {
        const t = this.options.element.clientWidth
          , e = this.options.element.clientHeight;
        this.camera.left = t / -2;
        this.camera.right = t / 2;
        this.camera.top = e / 2;
        this.camera.bottom = e / -2;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(t, e);
        this.renderer.setPixelRatio(window.devicePixelRatio || 1)
    }
}

new BlobObject({
    element: document.getElementById('container'),
    zoom: 2,
    color: 2434341
})